export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-16"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-950/40 via-background-50 to-background-50"></div>
        <div className="absolute top-0 right-0 w-[60%] md:w-[50%] h-full opacity-30 md:opacity-40">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20streaming%20platform%20interface%20with%20glowing%20movie%20posters%20in%20a%20grid%20layout%2C%20warm%20amber%20and%20coral%20accent%20lights%2C%20modern%20dark%20UI%20design%2C%20luxurious%20home%20theater%20atmosphere%2C%20subtle%20film%20grain%20texture%2C%20professional%20entertainment%20platform%20aesthetic%2C%20rich%20deep%20blacks%20with%20soft%20warm%20highlights&width=1200&height=900&seq=hero-cinema-bg&orientation=landscape"
            alt="黄瓜影院高清影视平台"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs md:text-sm font-medium text-primary-400 bg-primary-500/10 rounded-full border border-primary-500/20 mb-4 md:mb-5">
              <i className="ri-fire-fill mr-1.5"></i>每日更新 · 海量片库
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-950 tracking-wide leading-tight mb-3 md:mb-4">
              黄瓜影院
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-primary-400 mt-1">
                高清影视在线观看平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-light mb-2 md:mb-3">
              不缓冲 · 不卡顿 · 即点即播
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl lg:max-w-none mb-6 md:mb-8">
              黄瓜影院汇聚全网高清影视资源，涵盖最新电视剧全集、热门电影大全、人气综艺与经典动漫。依托智能推荐引擎，根据您的观影偏好精准匹配优质内容。每日同步更新最新剧集，高清画质流畅播放，无需等待缓冲，畅享沉浸式追剧体验。无论是最新上线的热门大片，还是经典回味的老剧珍藏，黄瓜影院都是您的一站式高清影视平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-accent-500/10">
                  <i className="ri-movie-line text-lg md:text-xl text-accent-400"></i>
                </div>
                <div>
                  <p className="text-lg md:text-xl font-bold text-foreground-900">2.8万+</p>
                  <p className="text-xs text-foreground-500">影视资源</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-500/10">
                  <i className="ri-user-heart-line text-lg md:text-xl text-primary-400"></i>
                </div>
                <div>
                  <p className="text-lg md:text-xl font-bold text-foreground-900">860万+</p>
                  <p className="text-xs text-foreground-500">活跃用户</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-secondary-500/10">
                  <i className="ri-shield-check-line text-lg md:text-xl text-secondary-400"></i>
                </div>
                <div>
                  <p className="text-lg md:text-xl font-bold text-foreground-900">全天候</p>
                  <p className="text-xs text-foreground-500">稳定服务</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-center no-underline"
              >
                <i className="ri-play-circle-fill mr-2"></i>立即观影
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto px-8 py-3.5 border border-background-300 hover:border-primary-400/50 text-foreground-700 hover:text-primary-400 font-medium text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-center no-underline"
              >
                <i className="ri-information-line mr-2"></i>了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg xl:max-w-xl">
            <div className="relative">
              <div className="aspect-[4/5] md:aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20showcase%20wall%20displaying%20multiple%20film%20posters%20with%20warm%20dramatic%20lighting%2C%20dark%20theater%20ambiance%2C%20elegant%20gold%20and%20coral%20accent%20details%2C%20professional%20cinema%20aesthetic%2C%20rich%20velvet%20textures%2C%20sophisticated%20entertainment%20atmosphere%2C%20no%20visible%20text%20on%20posters&width=800&height=1000&seq=hero-poster-showcase&orientation=portrait"
                  alt="黄瓜影院影视海报墙"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 md:-bottom-4 md:-right-4 bg-background-100 rounded-lg px-4 py-2.5 md:px-5 md:py-3 border border-background-200/60">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">正在更新中...</span>
                </div>
                <p className="text-sm md:text-base font-bold text-accent-400 mt-1 whitespace-nowrap">
                  <i className="ri-fire-fill mr-1"></i>今日上新 36 部
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}